module.exports = __webpack_public_path__ + "static/media/lte5.dc155c03.jpg";